import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { PrType, ProductTypeService, PrTypeData } from '../../services/product-type.service';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { Utils } from '../../util';

@Component({
  selector: 'app-update-pr-c-type',
  templateUrl: './update-pr-c-type.component.html',
  styleUrls: ['./update-pr-c-type.component.css']
})
export class UpdatePrCTypeComponent implements OnInit,OnDestroy {

  errorCode: boolean;

  prTypeForm: FormGroup;
  reportSelect: any[];
  sid: string;
  prType: any;

  constructor(
    private prTypeService: ProductTypeService,
    private data: PrTypeData,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.sid = this.activatedRoute.snapshot.paramMap.get('id');
    this.reportSelect = Utils.array(this.data.reports).map(([name, value]) => ({value, name}));
  }

  ngOnInit() {
    this.createForm();
    let sub = this.prTypeService.getPrType(this.sid).subscribe(({report='key0', ...data}) => {
      sub.unsubscribe();
      this.prType = data;
      this.prTypeForm.get('name').setValue(data.name);
      this.prTypeForm.get('description').setValue(data.description);
      this.prTypeForm.get('code').setValue(data.code);
      this.prTypeForm.get('report').setValue(report);
    });
  }

  ngOnDestroy() {
  }

  createForm() {
    this.prTypeForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      code: ['', Validators.required],
      report: 'key0'
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    value.selection = 'compra';
    let sub = this.prTypeService.codeExistCompra(value.code).subscribe(data => {
      sub.unsubscribe();
      if((data.length && data[0].id == this.sid) || !data.length){
        this.prTypeService.updatePrType(this.sid, value);
      }else{
        this.errorCode=true;
      }
    });
    
  }
}
